export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA',
  'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT',
  'VA', 'WA', 'WV', 'WI', 'WY',
] as const;

export const WORK_COUNTIES = ['North San Diego', 'Riverside'] as const;
export const WEEKDAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;

export const CAREGIVER_LANGUAGES = [
  'English', 'Spanish', 'Tagalog', 'Vietnamese', 'Chinese (Mandarin or Cantonese)',
  'Arabic', 'Korean', 'Japanese', 'German', 'French', 'Other',
] as const;

export const CAREGIVER_EXPERTISE = [
  "Dementia/Alzheimer's Care", 'Post Surgery Care', 'Meal Preparation', 'Mobility Assistance',
  'Personal Care', 'Companionship', 'Medical Management', 'End-of-Life Care', 'Other',
] as const;

export const CAREGIVER_CERTIFICATIONS = [
  'CNA (Certified Nursing Assistant)', 'CPR/First Aid', 'Hospice Care',
  'HHA (Home Health Aide)', 'Dementia Care Specialist', 'Other',
] as const;
